import React, { useEffect } from 'react';

// Utils
import { SignalRStripePaymentFlowResponse } from '@/main/models/common/signalRReceiveUpdatesResponse';
import { StripePaymentFlowProgressEnum } from '@/main/services/enum/StripePaymentFlowProgressEnum';
import { isNullUndefined } from '@/main/services/utils';
import { useNavigate } from 'react-router-dom';
import { RoutesConstants } from '@/main/routes/routesConstants';
interface HubItemStripePaymentFlowProps {
  data: SignalRStripePaymentFlowResponse[];
  customProps?: {
    onFinishedRequote: () => void;
    onErrorRequote: () => void;
  }
}

const HubItemStripePaymentFlow = ({ data, customProps }: HubItemStripePaymentFlowProps) => {
  const formatteedData = isNullUndefined(data) ? [] : data;
  const navigate = useNavigate();
  useEffect(() => {

    if (isNullUndefined(formatteedData)) return;
    const lastItemSignalR = formatteedData[formatteedData.length - 1];
    if (isNullUndefined(lastItemSignalR)) return;

    if (lastItemSignalR.progressStatus === StripePaymentFlowProgressEnum.CheckoutSessioncompleted) {
      navigate(`${RoutesConstants.orderSearchOrder}?quoteFilterVehicle=${lastItemSignalR.codeQuote}`);
    }

    if (lastItemSignalR.progressStatus === StripePaymentFlowProgressEnum.PaymentSuccessfull) {
    }
  }, [JSON.stringify(formatteedData)])


  return (
    <>
    </>
  );
};

export default HubItemStripePaymentFlow;
